//Background info:
// https://stackoverflow.com/questions/30233302/promise-is-it-possible-to-force-cancel-a-promise
// https://stackoverflow.com/questions/1973140/parsing-json-from-xmlhttprequest-responsejson

interface ITokenFn {
  cancel: () => void;
}

export const fetchWithCancel = (url: string, token: ITokenFn) => {
  // the token is for cancellation
  var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  xhr.open("GET", url);
  return new Promise<any>(function (resolve: any, reject: any) {
    xhr.onload = function () {
      resolve(JSON.parse(xhr.responseText));
    };
    xhr.onerror = reject;
    token.cancel = function () {
      // specify cancellation
      xhr.abort(); // abort request
      reject(new Error("Cancelled")); // reject the promise
      console.log("request cancelled");
    };
    xhr.send(null);
  });
};
